import client from '../httpClient';

const sendmailGetUnsendApi = (params) => {
  return client.get('/send-mails/get-unsend-mail', { params });
};

export default sendmailGetUnsendApi;
